import React from 'react';
import RenderSpotSniffpass from './render-spot-sniffpass';
import { formatRating, formatReviewCountText } from '../../helpers/rating';
import LastActiveBanner from '../../components/last-active-banner';
import SpotTopBadge from '../../components/spot-top-badge';
import SvgStarSolid from 'src/assets/svg/SvgStarSolid.svg';

const RenderSubInfo = ({
    spot,
    handleGoTo,
    handleSniffpassBadge,
    publicPark,
    isSpotLastActTest,
    lastActiveAt,
    spotPublishedAt,
    isRecentReviewsTest,
}) => {
    // eslint-disable-next-line no-undef
    const reviewsText = spot.reviewsCount > 0 ? formatReviewCountText(spot.reviewsCount) : 'No reviews yet';

    // Get the appropriate rating based on the test
    const effectiveRating = isRecentReviewsTest ? spot.effectiveRatingV2 || spot.rating : spot.rating;

    return (
        <div className="sdp-render-sub-info">
            <div className="mobile-sub-info">
                {effectiveRating !== null && (
                    <>
                        <SvgStarSolid className="sub-star" />
                        <span className="sub-rating">{formatRating(effectiveRating)}</span>
                        <span className="dot-separator" />
                    </>
                )}
                <span className="sub-reviews" onClick={handleGoTo}>
                    {reviewsText}
                    <div className="dotted-underline" />
                </span>
            </div>
            {!publicPark && (
                <>
                    <div className="mobile-sub-badges">
                        <SpotTopBadge spot={spot} />
                        <div className="d-flex d-md-none">{spot.offerSniffpass && <RenderSpotSniffpass {...{ handleSniffpassBadge }} />}</div>
                    </div>
                    {isSpotLastActTest && <LastActiveBanner {...{ lastActiveAt, spotPublishedAt }} />}
                </>
            )}
        </div>
    );
};

export default RenderSubInfo;
